import LocalizedMessage from './LocalizedMessage';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateField from './DateField';
import { useTranslation } from 'react-i18next';

export const isValidDateValue = value => moment(value, 'YYYY-MM-DD', true).isValid();

function PolishDateInput({ label, name, value, readOnly, error, onChange, onBlur }) {
  const { t: tr } = useTranslation();
  return (
    <div className="form-group">
      <span><strong>{label}</strong></span>
      <div className="input-group mt-1">
        <DateField
          name={name}
          aria-label={label}
          placeholder={tr("public:ddmmyyyy_17")}
          className={`form-control${error ? ' is-invalid' : ''}`}
          value={value}
          readOnly={readOnly}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete="off"
        />
        <div className="invalid-feedback"><LocalizedMessage isError value={error} /></div>
      </div>
    </div>
  );
}

PolishDateInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ key: PropTypes.string.isRequired, params: PropTypes.object })]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};
PolishDateInput.defaultProps = { value: '', readOnly: false, error: undefined };

export default PolishDateInput;
